import { checksApi } from './api/endpoints';
import type { Check } from './api/types';

/** Save a Blob under a file name. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export function reportFileName(check: Check): string {
  return `visa-status-${check.passport_no}-${(check.finished_at ?? check.created_at).slice(0, 10)}.pdf`;
}

/** Download the backend-generated status report. Only call when `check.report_url` is set. */
export async function downloadStatusReport(check: Check): Promise<void> {
  if (!check.report_url) throw new Error('The report is only available when the visa is ACTIVE.');
  saveBlob(await checksApi.file(check.report_url), reportFileName(check));
}
